import MappingBase from './mappingBase.js';

/**
 * Address model for salon locations.
 * All aliases use "a" prefix (Address namespace).
 */
class Address extends MappingBase {
  constructor({
    street = null,
    interior = null,
    neighborhood = null,
    city = null,
    municipality = null,
    state = null,
    postal_code = null,
    country_code = "MX",
    formatted_address = null,
    place_id = null,
    latitude = null,
    longitude = null,
  } = {}) {
    super();
    this.street = street;
    this.interior = interior;
    this.neighborhood = neighborhood;
    this.city = city;
    this.municipality = municipality;
    this.state = state;
    this.postal_code = postal_code;
    this.country_code = country_code;
    this.formatted_address = formatted_address;
    this.place_id = place_id;
    this.latitude = latitude;
    this.longitude = longitude;
  }

  static _aliasMapping = {
    astr: "street",
    aint: "interior",
    anbh: "neighborhood",
    aci: "city",
    amun: "municipality",
    asta: "state",
    azip: "postal_code",
    acc: "country_code",
    afad: "formatted_address",
    apid: "place_id",
    alat: "latitude",
    alon: "longitude",
  };
}

export default Address;
